import { Link as RouterLink } from 'react-router-dom'
import { Link as FrokLink, useHeaderContext } from '@bosch/react-frok'

import { LinkProps } from './types/LinkTypes'

const Link = ({ href, label }: LinkProps) => {
    const headerState = useHeaderContext()

    const onClick = () => {
        headerState.requestToggleMenu()
    }

    return (
        <FrokLink as={RouterLink} to={href} label={label} onClick={onClick} />
    )
}

export default Link
